import React from "react";
import { Navigate } from "react-router-dom";

import { usePermissionRequirement } from "~/hooks/usePermission";
import { type PermissionRequirement } from "~/modules/Auth/permissionRequirement";

interface PermissionGuardProps {
  children: React.ReactElement;
  requirement: PermissionRequirement;
}

export const PermissionGuard = ({ children, requirement }: PermissionGuardProps): React.ReactElement => {
  const isAllowed = usePermissionRequirement(requirement);
  return isAllowed ? children : <Navigate to="/dashboard" replace />;
};
